import { render, staticRenderFns } from "./OrderFlowSalonPage.vue?vue&type=template&id=834c1a10&scoped=true"
import script from "./OrderFlowSalonPage.vue?vue&type=script&lang=js"
export * from "./OrderFlowSalonPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834c1a10",
  null
  
)

export default component.exports